import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Sketch from '../components/sketch'
import {Howl, Howler} from 'howler';


class Slider extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0


    this.ref = {
      trigger: null,
      img: [],
      logo: null
    }

  }

  mount() {

    

    this.sketch = new Sketch({
     
        duration: .8,
        uniforms: {
            intensity: {
                value: 0.93,
                type: 'f',
                min: 0.,
                max: 6
            },
        },
        fragment: `
		uniform float time;
		uniform float progress;
		uniform float width;
		uniform float scaleX;
		uniform float scaleY;
		uniform float transition;
		uniform float radius;
		uniform float intensity;
		uniform sampler2D texture1;
		uniform sampler2D texture2;
		uniform sampler2D displacement;
		uniform vec4 resolution;
		varying vec2 vUv;

		void main() {
		  vec2 newUV = (vUv - vec2(0.5)) * resolution.zw + vec2(0.5);

		  vec4 d1 = texture2D(texture1, newUV);
		  vec4 d2 = texture2D(texture2, newUV);

		  float displace1 = (d1.r + d1.g + d1.b) * 0.33;
		  float displace2 = (d2.r + d2.g + d2.b) * 0.33;

		  vec4 t1 = texture2D(texture1, vec2(newUV.x + progress * (displace2 * intensity), newUV.y));
		  vec4 t2 = texture2D(texture2, vec2(newUV.x + (1.0 - progress) * (displace1 * intensity), newUV.y));

		  gl_FragColor = mix(t1, t2, progress);

		}

	`
    });
    
    this.bindedshow = this.change.bind(this)
    this.delayedCall = gsap.delayedCall(1.13, this.bindedshow)
  

    


    if (this.ref.logo) {
      this.paralax = gsap.fromTo(
        this.ref.logo, {
          ease: 'none',
          yPercent: 0
        }, {
          scrollTrigger: {
            trigger: this.ref.trigger,
            start: 'top top+=1%',
            end: "bottom top",
            id: 'trig',
            scrub: true,
            onToggle: self => {
              
              this.paused = !self.isActive
              this.element.classList.toggle('is-paused', !self.isActive)
              this.change()
            }
          },
          ease: 'none',
          yPercent: 40
        }
      )
    }
    
    if (this.paralax.scrollTrigger) {
      this.paused = !this.paralax.scrollTrigger.isActive
    }
    else(
      this.paused = true
    )
    
    //console.log(this.paralax.scrollTrigger.isActive)
    
}

change() {

  

if (!this.paused) {
  
  
  this.delayedCall.kill()
  this.delayedCall = gsap.delayedCall(1.13, this.bindedshow)
  this.index = gsap.utils.wrap(0, this.sketch.textures.length, ++this.index)
  this.sketch.next(this.index)
 // this.next(this.index)
  


}


}

// show() {

//   if (!this.paused){
//     this.ref.img[this.current].classList.remove('seq__img--v')
//     this.current = gsap.utils.wrap(0, this.ref.img.length, ++this.index)
//     this.ref.img[this.current].classList.add('seq__img--v')
//   }

  

// }





  unmount() {
    ScrollTrigger.getById("trig").kill();
    this.paralax.kill()

    this.paused = true
    this.delayedCall.kill()
    
   
   
    this.bindedshow = null

    this.sketch.destroy()
    


  }


}

module.exports = Slider
